import moment from "moment/moment";

// *Email Regex
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// *Password Regex
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_~=@#$>.<,[{}()!%\|'"`:;+*?&])[A-Za-z\d_~=@#$>.<,[{}()!%\|'"`:;+*?&]{8,}$/
// export const passwordRegex = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/

// *Mobile Regex
// export const mobileRegex = /^(\+92)?(0)?3[0-9]{9}$/    //* Old Regex
export const mobileRegex = /^(\+92)[0-9]{10}$/

// *Business Mobile Regex
export const businessMobileRegex = /^\+[0-9]{7,15}$/

// *Card Regex
export const cardRegex = /^\d{16}$/
// export const cardRegex = /^4[0-9]{12}(?:[0-9]{3})?$/
export const cvvRegex = /^[0-9]{3}$/
export const expireMonthRegex = /^(0?[1-9]|1[012])$/
export const expireYearRegex = /^\d{4}$/

// *Contact Details
export const supportEmail = 'b2b.hashtag@gmail.com'
export const supportMobile = '+92 341 3131113'
export const supportAddress = 'Central Plaza, Suite 9110 9th Floor, Marston Road Saddar, Karachi, Pakistan, Karachi, Pakistan, 75200'
export const facebookLink = 'https://www.facebook.com/profile.php?id=61575117807832'
export const instagramLink = 'https://www.instagram.com/b2b.hashtag/'
export const youtubeLink = 'https://www.youtube.com/@B2BHASHTAG'
export const tiktokLink = 'https://www.tiktok.com/@hashtagb2b?_r=1&_t=ZS-936BoIBkUlx'

// *Currency
export const currency = "Rs "

// *Manufacturer Type Id
export const ManufacturerTypeId = 2

// *Drop Shipper Type Id
export const DropShipperTypeId = 3

// *Supplier Type Id
export const SupplierTypeId = 4

// *Guest Buyer Type Id
export const GuestBuyerTypeId = 5

// *Capitalize
export const Capitalize = (str) => {
  const array = str.split(" ");

  for (var i = 0; i < array.length; i++) {
    array[i] = array[i].charAt(0).toUpperCase() + array[i].slice(1);
  }
  const capitalString = array.join(" ");
  return capitalString
}

// *For Date Format
export const getDateFormate = (date) => {
  if (!date) return
  const newDate = moment(date).format('YYYY-MM-DD')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const getDate = (date) => {
  if (!date) return
  const newDate = moment(date).format('DD-MM-YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const getDateTime = (date) => {
  if (!date) return
  const newDate = moment(date).format('DD-MMM-YYYY  h:mm A')
  return newDate
}

// *For Debounce
let debounceTimer;
export const Debounce = (func, delay = 1000) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
};

// *For Set Query Params
export const setQueryParams = (params) => {
  const searchParams = new URLSearchParams(window.location.search);
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      searchParams.set(key, params[key]);
    } else {
      searchParams.delete(key);
    }
  });
  return searchParams.toString();
};

export const splitWeight = (weightStr) => {
  const index = weightStr.search(/[a-zA-Z]/);
  // if (index === -1) throw new Error(`No unit found in: ${weightStr}`);

  const value = parseFloat(weightStr.slice(0, index).trim());
  // const unit = weightStr.slice(index).trim().toLowerCase();

  return value;
}

export const maskPhoneNumber = (phone) => {
  if (!phone) return "";
  const str = phone.toString();
  if (str.length < 7) return str;

  return str.slice(0, 5) + "****" + str.slice(-3);
}

export const maskEmail = (email) => {
  if (!email) return "";
  const [user, domain] = email.split("@");
  if (user.length <= 2) return `**@${domain}`;

  return `${user.substring(0, 2)}***${user.slice(-1)}@${domain}`;
}

// *Login ke baad wapas usi page par bhejne ke liye
// (jaise product page se "Add To Cart" -> login -> wapas wahi product page)
export const getCurrentPath = () => {
  if (typeof window === 'undefined' || !window.location) return '/'
  const { pathname, search } = window.location
  return `${pathname || '/'}${search || ''}`
}

// *Sirf app ke andar ki safe paths allow karo (open-redirect se bachne ke liye)
export const getSafeRedirectPath = (path) => {
  if (typeof path !== 'string') return null
  const trimmed = path.trim()
  if (!trimmed.startsWith('/')) return null      // sirf internal path
  if (trimmed.startsWith('//')) return null      // protocol-relative URL nahi
  if (trimmed.startsWith('/login')) return null  // loop se bachne ke liye
  return trimmed
}

// *Login page ka URL (redirect target ke saath)
export const getLoginUrl = () => {
  const safePath = getSafeRedirectPath(getCurrentPath())
  return safePath ? `/login?redirect=${encodeURIComponent(safePath)}` : '/login'
}
